export default "__VITE_ASSET__rQ7NC2Lm__"